import { Pill, Stack, Text, useText } from "@sveabank/cc-common";
import Paper from "../../components/paper";
import type { FullApplicationData } from "../../types/application";

type Props = { application: FullApplicationData };

const ApplicationUnderReview = ({ application }: Props) => {
	const [t, texts] = useText();

	return (
		<Paper key={application.applicationId}>
			<Stack gap={2}>
				<Pill status="success" text={t(texts.dashboardPage.applications.statuses.finalized)} />
				<Text className="text-sm">
					{t(texts.dashboardPage.applications.statusDescriptions.manualHandling)}
				</Text>
				<Text component="h4" className="text-text-primary text-xl" bold>
					{application.name}
				</Text>
				<Text>{application.orgNrDisplayName}</Text>
			</Stack>
		</Paper>
	);
};

export default ApplicationUnderReview;
